import {useDispatch, useSelector} from "react-redux";
import {Navigate, NavLink, Route} from "react-router-dom";
import React, {useEffect} from "react";
import Login from "./Login";
import {Routes} from "react-router";
import AccountMain from "./AccountMain";
import s from './Account.module.css';
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import Registration from "./Registration";
import Success from "./Success";
import ChangePassword from "./ChangePassword";
import AccountAdress from "./AccountAdress";
import DontLogin from "./DontLogin";
import ResetPassword from "./ResetPassword";
import {readUserData} from "../../firebase";
import {setUserData} from "../../store/UserInfoSlice";
import {logout} from "../../store/AuthSlice";
import EditProfile from "./Edit/EditProfile";
import EditAdress from "./Edit/EditAdress";
import AccountOrders from "./AccountOrders";
import Liked from "./Liked";
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";


const Account = () => {
    const isAuth = useSelector(state => state.authUser.isAuth);
    const userId = useSelector(state => state.authUser.userId);
    const dispatch = useDispatch();

    const logoutUser = () => {
        dispatch(dispatch(logout()));
        dispatch(setUserData({
            name: null,
            surname: null,
            phone: null,
            country: null,
            region: null,
            city: null,
            address: null,
        }))
    }

    useDocumentTitle('Личный кабинет');


    useEffect(() => {
        readUserData(userId).then((userInfo) => {
            dispatch(setUserData({
                name: userInfo.name,
                surname: userInfo.surname,
                phone: userInfo.phone,
                country: userInfo.country,
                region: userInfo.region,
                city: userInfo.city,
                address: userInfo.address,
            }))
        });
    }, []);

    return (
        <div>
            <div className={s.account}>
                <div className={`${s.accountContent} content`}>
                    <Breadcrumbs/>
                    <div className={s.accountMain}>
                        <div className={s.accountMainPages}>
                            <Routes>
                                <Route path="" element={<AccountMain/>}/>
                                <Route path="login" element={<Login/>}/>
                                <Route path="registration" element={<Registration/>}/>
                                <Route path="success" element={<Success/>}/>
                                <Route path="change-password" element={<ChangePassword/>}/>
                                <Route path="reset-password" element={<ResetPassword/>}/>
                                <Route path="edit-profile" element={<EditProfile/>}/>
                                <Route path="edit-adress" element={<EditAdress/>}/>
                                <Route path="address" element={isAuth ? <AccountAdress/> : <DontLogin/>}/>
                                <Route path="orders" element={isAuth ? <AccountOrders/> : <DontLogin/>}/>
                                <Route path="liked" element={isAuth ? <Liked/> : <DontLogin/>}/>
                            </Routes>
                        </div>
                        <div className={`${s.accountSidebar} accountSidebarActive`}>
                            <ul>
                                {isAuth ? <li><NavLink end to="">Личный кабинет</NavLink></li> : null}
                                {isAuth ? null : <li><NavLink to="login">Вход</NavLink></li>}
                                {isAuth ? null : <li><NavLink to="registration">Регистрация</NavLink></li>}
                                {isAuth ? null : <li><NavLink to="reset-password">Забыли пароль?</NavLink></li>}
                                {isAuth ? <li><NavLink to="edit-profile">Редактировать информацию</NavLink></li> : null}
                                {isAuth ? <li><NavLink to="change-password">Изменить пароль</NavLink></li> : null}
                                <li><NavLink to="address">Адрес</NavLink></li>
                                <li><NavLink to="orders">История заказов</NavLink></li>
                                <li><NavLink to="liked">Избранные</NavLink></li>
                                {isAuth ? <li onClick={() => logoutUser()}>Выход</li> : null}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Account;